import { ReactElement } from 'react';
import { useNavDrawers } from './use-nav-drawer';
import { useLocation } from 'react-router-dom';
import { FR_UNITS_LIST_PATH } from '../../router/constants';
import { FrNavItemLink } from './fr-nav-item-link';
import { FrNavItem } from './fr-nav-item';

export function UnitsListNavItem({ label }: { label?: string }): ReactElement {
    const { isDrawerOpen, toggleDrawer } = useNavDrawers('fr-units-list');

    const location = useLocation();
    const isFrUnitsListPath = location.pathname.includes(FR_UNITS_LIST_PATH);

    if (isFrUnitsListPath) {
        return (
            <FrNavItemLink
                to={FR_UNITS_LIST_PATH}
                data-testid="units-list-nav-link-nav"
                icon="Unit"
                label={label}
            />
        );
    }

    return (
        <FrNavItem
            icon="Unit"
            isActive={isDrawerOpen}
            label={label}
            data-testid="units-list-nav-link-nav"
            style={{ marginBottom: 8 }}
            onClick={toggleDrawer}
        />
    );
}
